<div
  [style]="{ height }"
  class="flex flex-col flex-wrap justify-center content-center items-center w-full">
  <img
    alt="{{ title }}"
    [style]="{ '-webkit-user-drag': 'none', width }"
    class="mb-4"
    src="assets/images/creative/{{ creative }}" />
  <div class="h4 text-gray-800 mb-3">{{ title }}</div>
  <span class="sh1 text-gray-800" [innerHTML]="description"></span>
</div>
